import {Component, OnInit} from '@angular/core';
import {createSelector, select, Store} from '@ngrx/store';
import {Observable} from 'rxjs';
import {TenantInfo} from '../../models/tenant.model';
import {AppState} from '../../store';
import {isAdmin, selectSessionLanguage, selectTenantInfo, selectUser} from '../../store/selectors';
import {environment} from '../../../environments/environment';
import {SupportedLanguage} from '../../models/supported-language.model';
import {updateUserLanguage} from '../../store/user.actions';
import {User} from '../../models/user.model';
import {UrlBuilderService} from '../../services/url-builder.service';
import {TranslateModule} from '@ngx-translate/core';
import {LanguageDropdownComponent} from '../language-dropdown/language-dropdown.component';
import {AsyncPipe, NgClass, NgFor, NgIf, NgStyle} from '@angular/common';


interface FooterData {
  tenant: TenantInfo;
  user: User;
  isAdmin: boolean;
  sessionLanguage: SupportedLanguage;
}

const selectFooterData = createSelector(
  selectTenantInfo,
  selectUser,
  isAdmin,
  selectSessionLanguage,
  (tenant, user, isAdmin, sessionLanguage) => {
    return {
      tenant,
      user,
      isAdmin,
      sessionLanguage
    }
  }
);


@Component({
    selector: 'page-footer',
    templateUrl: './page-footer.component.html',
    styleUrls: ['./page-footer.component.scss'],
    standalone: true,
    imports: [NgIf, NgStyle, NgFor, LanguageDropdownComponent, NgClass, AsyncPipe, TranslateModule]
})
export class PageFooterComponent implements OnInit {

  data$: Observable<FooterData>;

  environment: any;

  facebookUrl:string;
  twitterUrl:string;
  instagramUrl:string;
  youtubeUrl:string;
  linkedinUrl:string;
  onlinecourseUrl:string;

  constructor(
    private store: Store<AppState>,
    private ub:UrlBuilderService) {

  }

  ngOnInit() {

    this.facebookUrl = this.ub.buildImageUrl("/images/footer/facebook.svg");
    this.twitterUrl = this.ub.buildImageUrl("/images/footer/twitter.svg");
    this.instagramUrl = this.ub.buildImageUrl("/images/footer/instagram.svg");
    this.youtubeUrl = this.ub.buildImageUrl("/images/footer/youtube.svg");
    this.linkedinUrl = this.ub.buildImageUrl("/images/footer/linkedin.svg");
    this.onlinecourseUrl = this.ub.buildImageUrl("/images/footer/logo.svg");

    this.data$ = this.store.pipe(select(selectFooterData));

    this.environment = environment;
  }

  onLanguageChanged(language: SupportedLanguage) {

    this.store.dispatch(updateUserLanguage({language}));

  }

  isLanguageDropdownVisible(data: FooterData) {

    return data?.isAdmin || data?.tenant?.languageConfig?.allowStudentsToOverride;

  }


  isPlatformLogoVisible(data: FooterData) {
    return !data.tenant?.instructorPricingPlan?.includes('enterprise');
  }
}
